module.exports = __webpack_public_path__ + "img/ic_save.0c822584.svg";